import Storage from "@/services/storage";
import { StorageConstants } from "@/enums/storage.enum";
import { OrderCardSummaryInterface } from "@/interface/business/order.interface";
import store from "@/store";
import { NAME_EN_AR_KEY } from "@/enums/orders.enum";

export default class OrderCardSummary implements OrderCardSummaryInterface {
  id: string = "";
  name: string = "";
  creation_time: string = "";
  update_time: string = "";
  order_option: string = "";
  branch_name: string = "";
  customer: string = "";
  address: string = "";
  phone: string = "";
  source: string = "";
  creator: string = "";
  creator_id: string = "";
  total: string = "";
  status: string = "";
  location_id: string = "";
  creator_name: string = "";

  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.creation_time = data?.creation_time;
    this.update_time = data?.update_time;
    this.order_option = data?.order_option?.name || "";
    this.location_id = data?.location_id;
    this.source = data?.source || "";
    this.status = data?.status || "";
    this.phone = data?.sale?.customer?.phone?.number || data.phone?.number || "";
    this.customer = this.getCustomerName(data?.sale?.customer || data?.customer_name);
    this.total = this.getPricePackage(data?.total_amount);
    this.address = this.getAddress(data);
    this.branch_name = this.getBranchName(data?.location_id);
    this.creator_id = data?.creator?.id || "";
    this.setCreatorName(data.creator);
  }

  getCustomerName(customer) {
    let name = customer;
    if (typeof customer === "object") {
      name = `${customer.first_name} ${customer.last_name || ""}`;
    }
    return name;
  }

  getBranchName(locationId) {
    const locations = Storage.get(StorageConstants.LOCATIONS);
    return locations?.find((location) => location.id === locationId)?.name || "";
  }

  getPricePackage(price = 0) {
    const currency = Storage.get(StorageConstants.BUSINESS)?.currency || "";
    return `${price / 1000} ${currency}`;
  }

  getAddress(data) {
    const { state } = <any>store;
    const address = data?.address || data?.sale?.customer?.address || data?.sale?.customer?.address?.[0];
    return `${address?.city?.[NAME_EN_AR_KEY[state.App.lang]] || ""} ${
      address?.area?.[NAME_EN_AR_KEY[state.App.lang]] || ""
    }`.trim();
  }

  setCreatorName(creator) {
    this.creator_name = creator?.name || creator || "";
    this.creator = this.creator_name
      ? this.creator_name
          ?.split(" ")
          ?.flatMap((i) => i[0][0])
          ?.join("")
      : "";
  }

  /**
   * Created At Formatter
   * @return {string}
   */
  public createdAt(fromNow: boolean = false): string {
    if (!fromNow) {
      return window.moment(this.creation_time || "")?.format("YYYY-MM-DD HH:mm");
    }
    return window.moment(this.creation_time || "")?.fromNow();
  }

  /**
   * Created At Formatter
   * @return {string}
   */
  public updatedAt(fromNow: boolean = false): string {
    if (!fromNow) {
      return window.moment(this.update_time || "")?.format("YYYY-MM-DD HH:mm");
    }
    return window.moment(this.update_time || "")?.fromNow();
  }
}

/**

 address: {id: "f5fa412a-2a03-4913-8647-dcf0752d40e8", label: "Address 1", residence: "BUILDING",…}
 creation_time: "2021-11-07T11:27:25.284000Z"
 creator: "Muntaser Almuhaisen"
 customer_name: "Montaser almohasen"
 id: "fd40c6fb-5db2-4d86-8893-42af59dbeb2f"
 issuer_id: "00000000-0000-0002-0002-000000000002"
 location_id: "b84b5503-f294-4a44-9dfd-6afe4f589c7e"
 name: "CC#0-Montaser almohasen"
 order_option: {id: "bd0453d9-9bfa-4dcd-ad09-1881b5526285", name: "pop-up", type: "DELIVERY",…}
 payment_status: ""
 phone: {id: "82aae2a3-002a-4372-9e83-450100736877", number: "962797590042", is_primary: true,…}
 sale_id: "b73691c7-8b4a-43d6-aac9-e46029d17d50"
 source: "CALLCENTER"
 status: "PENDING"
 ticket_number: "0"
 total_amount: 2847840
 update_time: "2021-11-07T11:27:36.357000Z"







 sale: {id: "b73691c7-8b4a-43d6-aac9-e46029d17d50", tax_on: true,…}
 combos: []
 customer: {id: "1cd349b8-a7c2-48cf-8842-d85b1c06d062", first_name: "Montaser", last_name: "almohasen",…}
 address: {id: "f5fa412a-2a03-4913-8647-dcf0752d40e8", label: "Address 1", residence: "BUILDING",…}
 apartment: "Appartment"
 area: {id: "748d88c0-90c0-40d8-94b3-70af8cc56eac", city_id: "7c9a833f-9fca-4831-81b3-fe9084dd7437",…}
 avenue: null
 block: null
 building: "Building No"
 city: {id: "7c9a833f-9fca-4831-81b3-fe9084dd7437", name_en: "Ammanz", name_ar: "عمان"}
 extras: "hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh"
 floor: "Floor No."
 id: "f5fa412a-2a03-4913-8647-dcf0752d40e8"
 is_primary: true
 is_verified: false
 label: "Address 1"
 position: {longitude: 35.9102365, latitude: 31.9541035}
 residence: "BUILDING"
 street: "د. الثالث"
 country: "JO"
 dob: null
 email: "m.almuhaisen@posrocket.com"
 first_name: "Montaser"
 gender: "UNSPECIFIED"
 id: "1cd349b8-a7c2-48cf-8842-d85b1c06d062"
 last_name: "almohasen"
 phone: {id: "82aae2a3-002a-4372-9e83-450100736877", number: "962797590042", is_primary: true,…}
 tags: []
 delivery: null
 external_fees: [{id: "00000000-0000-0000-1111-000000000000", name: "Delivery", type: "FIXED", intent: "DELIVERY",…}]
 id: "b73691c7-8b4a-43d6-aac9-e46029d17d50"
 items: [,…]
 loyalty: null
 order_option: {id: "bd0453d9-9bfa-4dcd-ad09-1881b5526285", name: "pop-up", type: "DELIVERY",…}
 tax_on: true
 temp_customer: null
 sequence_number: 54809
 serial_number: null
 source: "CALLCENTER"
 status: "PENDING"
 template: {id: "00000000-0000-4000-0000-000000000000", name: "Unspecified", status: 0}
 ticket_number: "0"
 total_amount: 2847840
 total_customers: 0
 transaction_id: null
 update_time: "2021-11-07T14:27:57.674000Z"






 acknowledged: false
 app_id: "00000000-0000-4000-0000-000000000000"
 category: {id: "00000000-0000-4000-0000-000000000000", name: "Unspecified"}
 comments: null
 creation_time: "2021-11-07T16:40:56.561000Z"
 creator: {id: "25ffedd0-5360-4207-bee1-d086b11ec70b", name: "Muntaser Almuhaisen",…}
 end_time: null
 id: "49b6b525-7f81-4093-a407-ef82c0c59ef6"
 issuer_id: "00000000-0000-0002-0002-000000000002"
 location_id: "b84b5503-f294-4a44-9dfd-6afe4f589c7e"
 name: "CC#0-Montaser almohasen"
 notes: {delivery_time: "", delivery_date: "", delivery_note: "", address_note: "", payment_status: ""}
 payment_methods: []
 pickup: null
 position: null
 sale: {id: "b73691c7-8b4a-43d6-aac9-e46029d17d50", tax_on: true,…}
 sequence_number: 55971
 serial_number: null
 source: "CALLCENTER"
 status: "CANCELED"
 template: {id: "00000000-0000-4000-0000-000000000000", name: "Unspecified", status: 0}
 ticket_number: "0"
 total_amount: 2847840
 total_customers: 0
 transaction_id: null
 update_time: "2021-11-07T17:53:58.864401Z"
 */
